import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDataContext } from '../../contexts/DataContext';
import { useQueryWithFarmIdAndMsg } from '../../utils/hooks';
import { getFirstQueryResult } from '../../utils/graphql';
import { searchBy } from '../../utils/search';
import LineItemsTable from '../tables/LineItemsTable';
import { ShrinkContentColumn } from '../ShrinkContent';

const TableTitle = styled.h1`
  margin: var(--header-margin-y) var(--cell-padding) 0px;
`;

// urlPrefix should include a trailing slash
const ResourcesTable = ({
  query,
  queryOptions,
  cols,
  newText,
  urlPrefix = '',
  filter,
  getQueryResult = getFirstQueryResult,
  title,
  className = '',
  ...props
}) => {
  const { isTemplate } = useDataContext();
  const { msg, data } = useQueryWithFarmIdAndMsg(
    query,
    {
      fetchPolicy: 'cache-and-network',
      ...queryOptions,
      includeFarmId: !isTemplate,
    },
    true,
  );
  const navigate = useNavigate();
  const getItems = (itemData) => {
    const items = getQueryResult(itemData);
    return items.map((item) => ({
      ...item,
      onClick: () => navigate(`${urlPrefix}${item.id}/edit`),
    }));
  };

  return (
    <ShrinkContentColumn>
      {title && <TableTitle>{title}</TableTitle>}
      <LineItemsTable
        className={`overflow-hidden ${className}`}
        data={data}
        msg={msg}
        cols={cols}
        getItems={getItems}
        createButton={newText}
        createButtonOnClick={() => navigate(`${urlPrefix}new`)}
        hover
        searchable
        showCount
        search={filter || searchBy(['name'])}
        {...props}
      />
    </ShrinkContentColumn>
  );
};

export default ResourcesTable;
